export default __webpack_public_path__ + "static/media/bourgogne.c74fafeb.svg";